import React from 'react';

/**
 * Simple PDF Viewer - Uses iframe to display PDF directly from server URL
 * No XHR, no CORS issues - the browser loads the PDF directly
 */
const PdfViewer = ({ pdfUrl, filename }) => {
  if (!pdfUrl) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: '#6c757d'
      }}>
        Loading PDF...
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: '#f5f5f5'
    }}>
      {/* Toolbar */}
      <div style={{
        padding: '0.5rem 0.75rem',
        borderBottom: '1px solid #dee2e6',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#fff'
      }}>
        <h4 style={{ margin: 0, fontSize: '0.9rem' }}>
          📄 {filename || 'Schedule PDF'}
        </h4>
        
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {/* Open in New Tab */}
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '0.35rem 0.75rem',
              backgroundColor: '#6c757d',
              color: 'white',
              borderRadius: '4px',
              textDecoration: 'none',
              fontSize: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.25rem'
            }}
          >
            🔗 Open in New Tab
          </a>
          
          {/* Open in Current Tab */}
          <a
            href={pdfUrl}
            style={{
              padding: '0.35rem 0.75rem',
              backgroundColor: '#007bff',
              color: 'white',
              borderRadius: '4px',
              textDecoration: 'none',
              fontSize: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.25rem'
            }}
          >
            📄 Open in Current Tab
          </a>
        </div>
      </div>

      {/* PDF Content - using iframe which loads directly from server */}
      <div style={{
        flex: 1,
        overflow: 'hidden'
      }}>
        <iframe
          src={pdfUrl}
          style={{
            width: '100%',
            height: '100%',
            border: 'none'
          }}
          title="Schedule PDF"
        />
      </div>
    </div>
  );
};

export default PdfViewer;
